import { useRouter } from 'next/router';

import cx from 'classnames';
import useDynamicFontSize from 'themes/canvas/components/utils';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import s from './EnergyHero.module.css';

interface HeroProps {
  imgSrc: string;
  businessName: string;
}

export const EnergyHero: React.FC<HeroProps> = ({ imgSrc, businessName }) => {
  const { theme } = useGGTheme();
  const paletteName = theme?.palette.name;

  const currentPalette =
    theme && theme.palette.name ? theme.palette.name.toLowerCase() : null;

  const router = useRouter();
  const isHomePage = router.pathname === '/';

  const { containerRef, fontSize, nowrapClass } =
    useDynamicFontSize(businessName);

  const overlapOffset = fontSize ? `${-0.85 * fontSize}px` : '-25px';

  const businessNameStyle: React.CSSProperties = {
    fontSize: fontSize ? `${fontSize}px` : 'inherit',
    transform: `translateY(${overlapOffset})`,
  };

  return (
    <section
      className={cx(
        s.root,
        {
          [s.energy]: paletteName === 'Energy' && isHomePage,
        },
        currentPalette && s[currentPalette],
      )}
      ref={containerRef}
    >
      <div
        className={s.heroContent}
        style={{
          backgroundImage: `url(${imgSrc})`,
        }}
      >
        <div className={cx(s.businessName, nowrapClass ? s.nowrapClass : '')}>
          <h1 style={businessNameStyle}>{businessName}</h1>
        </div>
      </div>
    </section>
  );
};
